import { Navigate, useParams } from "react-router-dom";
import { ROUTES } from "../../../../core/constants";
import MainLayout from "../../../../layouts/Main";
import { useAppDispatch, useAppSelector } from "../../../../store";
import { responseSelector } from "../../../../store/practices/selectors";
import {
  isBusySelector,
  responseSelector as regResponseSelector,
  hasErrorSelector as regHasErrorSelector,
  valuesSelector as regValuesSelector,
  errorSelector as regErrorSelector,
} from "../../../../store/registrations/selectors";
import { registerThunk } from "../../../../store/registrations";
import HeroResultUK from "./components/HeroResultUK";

function UnitedKingdomResultScene() {
  let { odscode } = useParams();
  const dispatch = useAppDispatch();
  const isBusy = useAppSelector(isBusySelector);
  const regResponse = useAppSelector(regResponseSelector);
  const regHasError = useAppSelector(regHasErrorSelector);
  const regError = useAppSelector(regErrorSelector);
  const practices = useAppSelector(responseSelector);
  const regValues = useAppSelector(regValuesSelector);

  const handleSubmit = (values: { [x: string]: string }) => {
    dispatch(registerThunk(values));
  };

  if (!practices) {
    return <Navigate to={ROUTES.unitedKingdom} />;
  }

  return (
    <MainLayout>
      <HeroResultUK
        handleSubmit={handleSubmit}
        isBusy={isBusy}
        isComplete={regResponse ? true : false}
        hasError={regHasError}
        error={regError}
        practice={
          practices
            ? practices.filter((practice) => practice.Code === odscode).pop()
            : null
        }
        values={regValues}
      />
    </MainLayout>
  );
}

export default UnitedKingdomResultScene;
